<template>
  <div>
    <sync-circle-icon v-if="loading" :spin="true"></sync-circle-icon>
    <span style="color: forestgreen" v-if="!loading && hasValidCredentials">
      <check-circle-icon></check-circle-icon>
    </span>
    <a-popover placement="topLeft" v-if="!loading && !hasValidCredentials">
      <template slot="content">
        Kon geen verbinding maken met Aplaza.
      </template>
      <span style="color: orangered">
      <close-circle-icon></close-circle-icon>
    </span>
    </a-popover>
  </div>
</template>

<script>
import aplazaUserApi from '~/api/aplazaUser';

export default {
  name: "ValidateUserCredentialsBadgeComponent",
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: true,
      hasValidCredentials: false,
    }
  },
  created() {
    aplazaUserApi.validateCredentials(this.userId).then(response => {
      this.loading = false;
      this.hasValidCredentials = response.data.valid;
    }).catch(error => {
      this.loading = false;
    });
  },
  mounted() {
  }
}
</script>
<style>
.material-design-icon.sync-circle-icon {
  animation: spin 1s linear infinite;
}

@-moz-keyframes spin {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>